// Server-driven, per-environment feature flags (mirrors the PinnacleClient system).
// A flag is identified by a string `code` and carries one boolean per environment.
// Flags are fetched from the backend (`cmdFeaturesNav`) and checked synchronously
// throughout the app via FeatureFlagService.isEnabled(code).

export type FeatureEnvironment = 'development' | 'alpha' | 'beta' | 'production';

// Lightweight shape returned by cmdFeaturesNav — used at runtime by isEnabled().
export interface FeatureFlag {
  code: string;
  development: boolean;
  alpha: boolean;
  beta: boolean;
  production: boolean;
}

// Maps the current FeatureEnvironment to the matching boolean column on FeatureFlag.
export const ENV_KEY_MAP: Record<FeatureEnvironment, keyof Omit<FeatureFlag, 'code'>> = {
  development: 'development',
  alpha: 'alpha',
  beta: 'beta',
  production: 'production',
};
